import { useTranslation } from 'next-i18next';
import Image from 'next/image';

// Both lists render dir='rtl', so the first entry is the rightmost on screen.
const platinumSponsors = [
  { src: '/images/sponsors/al-balad-development.png', name: 'Al Balad Development Co.' },
  {
    src: '/images/sponsors/jeddah-central-development.png',
    name: 'Jeddah Central Development Co.',
  },
];
const regularSponsors = [
  { src: '/images/sponsors/hankook.png', name: 'Hankook' },
  { src: '/images/sponsors/imc.png', name: 'IMC' },
  { src: '/images/sponsors/nike.png', name: 'Nike' },
  { src: '/images/sponsors/genesis.png', name: 'Genesis' },
  { src: '/images/sponsors/tcl.png', name: 'TCL' },
  { src: '/images/sponsors/flow.png', name: 'Flow' },
  { src: '/images/sponsors/milaf-cola.png', name: 'Milaf Cola' },
];

const Sponsors = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center gap-4 text-center'>
      <p className='capitalize'>{t('common:sponsors.reg')}</p>
      <ul dir='rtl' className='grid grid-cols-2 justify-center gap-2'>
        {platinumSponsors.map((sponsor) => (
          <li key={sponsor.src} className='grid place-items-center rounded-md bg-white'>
            <figure className='relative aspect-[3/2] w-28 md:min-w-32'>
              <Image
                src={sponsor.src}
                fill
                alt={sponsor.name}
                style={{ objectFit: 'contain' }}
                sizes='168px'
              />
            </figure>
          </li>
        ))}
      </ul>
      <ul dir='rtl' className='flex w-full max-w-lg justify-center gap-1 md:gap-2'>
        {regularSponsors.map((sponsor) => (
          <li
            key={sponsor.src}
            className='grid aspect-[3/2] w-full place-items-center rounded-md bg-white md:min-h-14'
          >
            <figure className='relative h-full w-full'>
              <Image
                src={sponsor.src}
                fill
                alt={sponsor.name}
                style={{ objectFit: 'contain' }}
                sizes='168px'
              />
            </figure>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sponsors;
